import { ErrorHandler, Injectable } from "@angular/core";
import { TrackJS } from "trackjs";

@Injectable({
  providedIn: "root"
})
export class TrackJsErrorHandler implements ErrorHandler {
  handleError(error:any) {
    console.warn(`TrackJs Error global handler caught this:`, error.message);
    TrackJS.track(error.originalError || error);
  }
}
